@use './../../../../../../styles/scss/vcom/mixins/breakpoints';

.vs-content-bundle-media {
  button {
    font-family: 'visa-icon', sans-serif;
    font-size: 24px;
    line-height: 100%;
    padding: 17px;
    cursor: pointer;
    position: absolute;
    top: calc(50%);
    left: calc(50%);
    transform: translate(-50%, -50%);

    &::before {
      content: '\e944';
    }

    &.vs-bundle-2up {
      @include breakpoints.desktop-plus-up {
        font-size: 34px;
        padding: 22px;
      }
    }
  }

  button.vs-bundle-play-white {
    background-color: white;
    border-radius: 50%;
    border-color: white;
    border-width: 1px;
    border-style: solid;
    box-shadow: 0 0 0 2px white;
    cursor: pointer;
    color: black;

    &:focus {
      border: 1px dashed black;
      outline: none;
    }
  }

  button.vs-bundle-play-black {
    background-color: black;
    border-radius: 50%;
    border-color: black;
    border-width: 1px;
    border-style: solid;
    box-shadow: 0 0 0 2px black;
    cursor: pointer;
    color: white;

    &:focus {
      border: 1px dashed white;
      outline: none;
    }
  }
}
